import { Flex, Spin } from 'antd'
import { t } from 'i18next'
import React from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import frLocale from '@fullcalendar/core/locales/fr'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import AvailableNowCard from '../AvailableNowCard'
import CreateEventCard from '../../EventsPage/CreateEventCard'
import CustModal from '../../../Common/CustModal'
import AppointmentCreationForm from '../../AppointmentsPage/AppointmentCreationForm'

dayjs.extend(weekday)
dayjs.extend(localeData)

export default function BoxCalendarPageXS ({
  box, appointmentModalVisible, loading, appointmentForm, setAppointmentModalVisible,
  onAdd, rangeDisable, boxAvailableNow, setRangeDisable, periods,
  loadCalendarData, day, businessHours, events, renderEventContent, selected, minHour, maxHour
}) {
  const dayheader = (date) => {
    const weekDayDisplay = { 0: 'D', 1: 'L', 2: 'M', 3: 'M', 4: 'J', 5: 'V', 6: 'S' }
    return <div>
      <div>{weekDayDisplay[date.format('d')]}</div>
      <div>{date.format('D')}</div>
    </div>
  }
  return (
    <>
      {box && <>
        <CustModal
          open={appointmentModalVisible}
          setOpen={setAppointmentModalVisible}
          title={t('Admin.BoxCalendar.popupTitle')}
          confirmLoading={loading}
          maskClosable={true}
          onOk={appointmentForm.submit}
        >
          <Spin spinning={loading}>
            <AppointmentCreationForm form={appointmentForm} onFinish={onAdd} rangeDisable={rangeDisable} />
          </Spin>
        </CustModal>
        <Flex vertical gap='1em' style={{ padding: '0.5em', backgroundColor: 'white' }}>
          <Flex justify='space-evenly'>
            {
              boxAvailableNow && <AvailableNowCard setModalVisible={setAppointmentModalVisible} setRangeDisable={setRangeDisable} form={appointmentForm} minimized={true} appointmentDuration={box.appointment_duration} />
            }
            <CreateEventCard box={box} minimized={true} />
          </Flex>
          <FullCalendar
            height="auto"
            viewClassNames='small-calendar'
            selectable={true}
            plugins={[timeGridPlugin, interactionPlugin]}
            headerToolbar={{ start: 'title', end: 'prev,next' }}
            firstDay={dayjs().day() - 1}
            initialDate={day || dayjs().format('YYYY-MM-DD')}
            initialView="timeGridWeek"
            dayHeaderContent={(args) => {
              return dayheader(dayjs(args.date))
            }}
            slotDuration="00:30:00"
            locale={frLocale}
            allDaySlot={false}
            displayEventTime={false}
            businessHours={businessHours(periods)}
            events={events}
            eventContent={renderEventContent}
            datesSet={loadCalendarData}
            selectLongPressDelay={150}
            select={(info) => selected(info)}
            slotMinTime={minHour + ':00:00'}
            slotMaxTime={maxHour + ':00:00'}
            nowIndicator={true}
          />
        </Flex>
      </>
      }
    </>
  )
}
